// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"58":"59c76d93d63371609b2c","151":"8f3380cfac6d8360016f","873":"297af7327eb1dd145513"}[chunkId] + ".js";
};